<template>
  <span>
    <i :id="`feature-indicator-${tag}`" class="mdi mdi-flask-outline indicator_icon" />
    <GTooltip :for="`#feature-indicator-${tag}`">
      {{ $t('notifications.feature_flag') }}
    </GTooltip>
  </span>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      tag: { type: String, required: true },
    },
  });
</script>

<style lang="scss" scoped>
  .indicator_icon {
    color: $color-warning;
  }
</style>
